"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Maximum number of items to display as part of a header for confirmation dialogs,
 * i.e. "Delete 10,000 items". If the number is greater than this value, then we'll
 * show the "VALUE+" instead.
 */
exports.MAX_LABEL_ITEM_COUNT = 10000;
/**
 * The threshold required to show a confirmation dialog. If the number
 * of selected items is lower than this value, we won't show a confirmation
 * dialog for whatever action is being performed.
 */
exports.NUMBER_OF_SELECTED_ITEMS_THRESHOLD = 25;
//# sourceMappingURL=bulkTriageConstants.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/utils/bulkTriageConstants.js
// module id = 3147
// module chunks = 20 62